// @flow
import React from 'react';
import { DatalayerScene } from '@finect/front-gtm';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { Head } from '@finect/tabular-components/Head';
import { PlusHero } from '../PlusHero';
import { MainContentStyled } from './partials';

type Props = {
  user?: Object,
  section: string,
  children: any,
  title?: string,
  withHello?: boolean,
  selectedTab?: {
    id: string,
    metaTitle: string
  }
};

export const PlusContainer = (props: Props) => {
  const { title = 'Finect Plus', user, children, section, withHello, selectedTab } = props;

  return (
    <>
      <Head title={selectedTab?.metaTitle || title} withoutName />
      <DatalayerScene pageType={`plus-${section}`} pageId={selectedTab?.id || section} />
      <PlusHero user={user} section={section} activeTab={section} withHello={withHello} />

      <Container fullWidth style={{ padding: '30px 15px' }}>
        <ContainerInner style={{ maxWidth: '100%' }}>
          <MainContentStyled width={'95%'}>{children}</MainContentStyled>
        </ContainerInner>
      </Container>
    </>
  );
};
